import { apiWithToken } from '../api';

const resouceUrl = '/config_autorizacao';
const token = localStorage.getItem('@token');
let api = apiWithToken(token);

export const load = async (params) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let page = urlParams.has('page') ? { page: urlParams.get('page') } : {};
  let search = urlParams.has('search')
    ? { search: urlParams.get('search') }
    : {};
  return await api.get(`${resouceUrl}`, {
    params: {
      ...params,
      ...page,
      ...search,
    },
  });
};

export const get_list_autorization = async (params) => {
  return await api.get(`${resouceUrl}/listar`, {
    params: {
      ...params,
    },
  });
};

export const select = async () => {
  return await api.get(`${resouceUrl}?fields=id,nome&raw_list`);
};

export const show = async (id) => {
  return await api.get(`${resouceUrl}/${id}`);
};

export const update = async (id, config_autorizacao) => {
  return await api.put(`${resouceUrl}/${id}`, config_autorizacao);
};

export const store = async (config_autorizacao) => {
  let response = await api.post(resouceUrl, config_autorizacao);
  return response;
};

export const destroy = async (id) => {
  return await api.delete(`${resouceUrl}/${id}`);
};

export const activate = async (id) => {
  return await api.post(`${resouceUrl}/${id}/activate`);
};
